import { Controller } from "@hotwired/stimulus"

const DURATION = 850
const easeOut = (t) => 1 - Math.pow(1 - t, 3)

// Animates the rail fill and counts XP up when a step has just been completed.
export default class extends Controller {
  static targets = ["fill", "xp"]
  static values = {
    from: Number,
    to: Number,
    fromPercent: Number,
    toPercent: Number,
  }

  connect() {
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches
    const unchanged = this.fromValue === this.toValue && this.fromPercentValue === this.toPercentValue

    if (reduceMotion || unchanged) {
      this.paint(this.toValue, this.toPercentValue)
      return
    }

    this.paint(this.fromValue, this.fromPercentValue)

    // Paint the starting state first so the fill has something to move from.
    window.requestAnimationFrame(() => {
      this.setFill(this.toPercentValue)
      this.countUp()
    })
  }

  disconnect() {
    if (this.frame) window.cancelAnimationFrame(this.frame)
  }

  paint(xp, percent) {
    this.setXp(xp)
    this.setFill(percent)
  }

  countUp() {
    const start = performance.now()
    const delta = this.toValue - this.fromValue

    const tick = (now) => {
      const progress = Math.min((now - start) / DURATION, 1)
      this.setXp(Math.round(this.fromValue + delta * easeOut(progress)))
      if (progress < 1) this.frame = window.requestAnimationFrame(tick)
    }

    this.frame = window.requestAnimationFrame(tick)
  }

  setXp(value) {
    this.xpTargets.forEach((target) => {
      target.textContent = value
    })
  }

  setFill(percent) {
    this.fillTargets.forEach((target) => {
      target.style.width = `${percent}%`
    })
  }
}
